<div [ngStyle]="{ background: tag.colour }">{{ tag.name }}</div>
